import React from 'react';
import { useNotifications, useNovu } from '@novu/react';

import { NotificationItem } from './notification-item';
import { PagePlaceholder } from '../../components/page-placeholder/page-placeholder';

import styles from './notifications-list.module.scss';
interface NotificationsListProps {
  /**
   *
   */
  ref?: React.Ref<HTMLAnchorElement>;

  /**
   * Additional action to run when clicking on an item
   */
  onItemClick?: () => void;
}

export const NotificationsList: React.FC<NotificationsListProps> = ({ ref, onItemClick }) => {
  const { notifications, isLoading } = useNotifications();

  if (isLoading) {
    return null;
  }

  if (notifications.length === 0) {
    return (
      <div className={styles['empty-placeholder-wrapper']}>
        <PagePlaceholder
          backgroundImgUrl={'/images/default-background.svg'}
          description="There are no messages to show."
        />
      </div>
    );
  }

  return notifications.map((notification, index) => (
    <NotificationItem
      ref={index === notifications.length - 1 ? ref : null}
      key={notification.id}
      notification={notification}
      onClick={onItemClick}
    />
  ));
};
